<template>
  <vs-popup
    :title="$t('AssignUsers') + ' برای ' + title"
    :active.sync="popupActive"
  >
    <vs-tabs vs-alignment="fixed" alignment="fixed">
      <vs-tab :label="$t('UsersList')" class="mt-2">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('UserName'), sort: 'UserName' },
                { title: $t('UserId') },
                { title: $t('MemberType') },
                { title: $t('CompanyNationalId') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 25%">
                  {{ row.name }}
                </td>
                <td style="width: 17%">
                  {{ row.ownerId }}
                </td>
                <td style="width: 17%">
                  {{ row.memberTypes == "Legal" ? "حقوقی" : "حقیقی" }}
                </td>
                <td style="width: 20%">
                  {{
                    row.companyNationalId
                      ? row.companyNationalId
                      : row.socialSecurityNumber
                  }}
                </td>
                <td style="width: 15%">
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="
                      deleteMemberInAgent(row.ownerId, row.partyId)
                    "
                    class="d-inline"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </vs-tab>
      <vs-tab :label="$t('AssignUsers')" class="mt-2">
        <add-user-popup
          :serialService="serialService"
          :currentAgentDataId="currentAgentData.id"
        ></add-user-popup>
      </vs-tab>
    </vs-tabs>
  </vs-popup>
</template>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import AddUserPopup from "./AddUserPopup";
export default {
  name: "",
  props: {
    show: { default: false },
    currentAgentData: { type: Object },
  },
  data() {
    return {
      gridDataSource: { data: [] },
      gridSearchData: {},
      title: "",
      serialService: "",
    };
  },
  computed: {
    popupActive: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  components: {
    DataGrid,
    AddUserPopup,
  },
  methods: {
    ...mapActions({
      fetchCitiesById: "country/fetchCitiesById",
      removeUserToAgents: "parties/removeUserToAgents",
    }),
    deleteMemberInAgent(ownerId, partyId) {
      this.$swal({
        title: "آیا از حذف این عضو اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          var model = {
            agentId: this.currentAgentData.id,
            ownerId: ownerId,
          };
          this.removeUserToAgents(model).then(() => {
            setTimeout(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت حذف شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$refs.grid.renderGrid();
            }, 200);
          });
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.title = this.currentAgentData.companyName
          ? this.currentAgentData.companyName
          : this.currentAgentData.firstName + this.currentAgentData.lastName;
        this.gridDataSource = {
          type: "app",
          service:
            "BusinessParties/api/AgentMembersQuery/" + this.currentAgentData.id,
        };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 200);
      }
    },
  },
};
</script>
